var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("template-listing-item-base", {
    attrs: {
      id: _vm.template.Id,
      name: _vm.template.Name,
      date: _vm.template.PublishDate,
      "can-delete": _vm.canDelete,
      "can-edit": _vm.canEdit
    },
    on: {
      "template-deleted": function($event) {
        return _vm.$emit("template-deleted", $event)
      },
      "template-selected": function($event) {
        return _vm.$emit("template-selected", $event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "sub-text-label",
        fn: function(ref) {
          var formattedDate = ref.formattedDate
          return [
            _vm.template.IsPublished
              ? [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.resource(
                          "TemplateRegularListingItem_Item_SubTextLabel_Published"
                        )
                      ) +
                      " " +
                      _vm._s(formattedDate) +
                      "\n        "
                  )
                ]
              : [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.resource(
                          "TemplateRegularListingItem_Item_SubTextLabel_NotPublished"
                        )
                      ) +
                      "\n        "
                  )
                ]
          ]
        }
      },
      {
        key: "additional-controls",
        fn: function() {
          return [
            _vm.canPublish
              ? _c("i", {
                  staticClass:
                    "fas fa-file-upload mdb-icon-btn new fa-lg mr-1 btn-publish",
                  class: { published: _vm.template.IsPublished },
                  attrs: { "aria-hidden": "true" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.promptPublish($event)
                    }
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }